/**
 * BusinessWindowFields: "só no expediente" e "dias da semana" de uma automação.
 *
 * Um componente para as quatro telas que agendam mensagem automática (régua
 * de resposta, trilha por etapa, lembrete de agendamento e agendar mensagem
 * do inbox), para a fiação não divergir entre elas. Só aparece com a flag
 * `automation_business_window` (AUTOMATION_BUSINESS_WINDOW_ENABLED).
 *
 * `value`: { business_hours_only: bool, weekdays: [] }
 * `weekdayFormat`: 'code' grava 'mon'..'sun' (régua); 'index' grava 0..6
 *   (follow-up, mesmo formato do recurrence_days).
 * O expediente e os feriados vêm de Agenda > Expediente (scheduling_config
 * do dono); membro sem expediente próprio herda o do administrador.
 */
import React from 'react';

const DIAS = [
  ['mon', 0, 'Seg'], ['tue', 1, 'Ter'], ['wed', 2, 'Qua'], ['thu', 3, 'Qui'],
  ['fri', 4, 'Sex'], ['sat', 5, 'Sáb'], ['sun', 6, 'Dom'],
];

const BusinessWindowFields = ({
  value, onChange, colors, weekdayFormat = 'code', compact = false,
}) => {
  const v = value || {};
  const businessOnly = !!v.business_hours_only;
  const selected = Array.isArray(v.weekdays) ? v.weekdays : [];
  const keyOf = (dia) => (weekdayFormat === 'index' ? dia[1] : dia[0]);
  const isOn = (dia) => selected.includes(keyOf(dia));
  const toggle = (dia) => {
    const k = keyOf(dia);
    const next = isOn(dia) ? selected.filter((d) => d !== k) : [...selected, k];
    onChange({ ...v, weekdays: next });
  };
  const c = colors || {};
  const fontSize = compact ? 12 : 13;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 10 }}>
      <label
        style={{
          display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
          fontSize, color: c.textPrimary, fontWeight: compact ? 500 : 600,
        }}
      >
        <input
          type="checkbox"
          checked={businessOnly}
          onChange={(e) => onChange({ ...v, business_hours_only: e.target.checked })}
          style={{ cursor: 'pointer' }}
        />
        Só no expediente
      </label>
      <div style={{ fontSize: 11, color: c.textTertiary, lineHeight: 1.45, marginTop: -4 }}>
        Fora do expediente, em feriado ou em dia sem atendimento a mensagem espera a
        próxima abertura. Expediente e feriados ficam em Agenda, Expediente.
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: c.textSecondary, marginRight: 2 }}>Dias:</span>
        {DIAS.map((dia) => {
          const on = isOn(dia);
          return (
            <button
              key={dia[0]}
              type="button"
              onClick={() => toggle(dia)}
              aria-pressed={on}
              style={{
                padding: '4px 9px', borderRadius: 999, fontSize: 11, cursor: 'pointer',
                border: `1px solid ${on ? (c.primary || '#2563eb') : (c.borderColor || '#ddd')}`,
                background: on ? (c.primary || '#2563eb') : 'transparent',
                color: on ? '#fff' : c.textSecondary,
              }}
            >
              {dia[2]}
            </button>
          );
        })}
        <span style={{ fontSize: 11, color: c.textTertiary }}>
          {selected.length === 0 ? 'nenhum marcado: todos os dias' : ''}
        </span>
      </div>
    </div>
  );
};

export default BusinessWindowFields;
